function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9176",
  "data-name": "Group 9176",
  transform: "translate(-693 -189)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(693 189)",
  fill: "#fff",
  opacity: 0.755
}), /*#__PURE__*/React.createElement("g", {
  id: "_01_Icons_Line_users",
  "data-name": "01) Icons / Line /  users",
  transform: "translate(699 194.859)"
}, /*#__PURE__*/React.createElement("path", {
  id: "users",
  d: "M15.436,17.641h-9.7a2.191,2.191,0,0,1-1.559-.646,2.221,2.221,0,0,1-.646-1.56v-.628A2.211,2.211,0,0,1,4.82,12.8l3.049-1.386a4.41,4.41,0,1,1,5.43,0L16.348,12.8a2.209,2.209,0,0,1,1.292,2.009v.628A2.19,2.19,0,0,1,17,16.994,2.221,2.221,0,0,1,15.436,17.641ZM8.786,11.965,5.186,13.6a1.324,1.324,0,0,0-.776,1.205v.628a1.323,1.323,0,0,0,1.323,1.323h9.7a1.324,1.324,0,0,0,1.323-1.323v-.628a1.325,1.325,0,0,0-.776-1.205l-3.6-1.636a4.376,4.376,0,0,1-1.793.382h-.011a4.373,4.373,0,0,1-1.792-.382Zm1.8-7.557a3.528,3.528,0,1,0,3.529,3.528A3.532,3.532,0,0,0,10.584,4.409Zm-8.379,9.7A2.208,2.208,0,0,1,0,11.906v-.687A2.2,2.2,0,0,1,1.2,9.258L4.158,7.733a4.41,4.41,0,1,1,6.548-5.8.441.441,0,0,1-.331.693h-.031a.438.438,0,0,1-.368-.2,3.528,3.528,0,1,0-4.754,5,.44.44,0,0,1-.046.776L1.6,10.041a1.32,1.32,0,0,0-.717,1.177v.687a1.325,1.325,0,0,0,1.323,1.323.441.441,0,0,1,0,.882Z",
  transform: "translate(2 2.002)",
  fill: "#687c97",
  stroke: "#687c97",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})));

function SvgUsersGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGray);
export default __webpack_public_path__ + "static/media/users-gray.c8569a96.svg";
export { ForwardRef as ReactComponent };